package co.maytes.standupbot.dashboard.pages.app.onboarding

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.layout.AuthGuard
import co.maytes.standupbot.dashboard.components.widgets.Button
import co.maytes.standupbot.dashboard.components.widgets.ButtonVariant
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideCalendar
import co.maytes.standupbot.dashboard.features.onboarding.BrandChip
import co.maytes.standupbot.dashboard.features.onboarding.ChipSize
import co.maytes.standupbot.dashboard.features.onboarding.FlowNode
import co.maytes.standupbot.dashboard.features.onboarding.OnboardingStep
import co.maytes.standupbot.dashboard.features.onboarding.WizardBrand
import co.maytes.standupbot.dashboard.features.onboarding.WizardFlow
import co.maytes.standupbot.dashboard.features.onboarding.WizardFrame
import co.maytes.standupbot.dashboard.features.onboarding.WizardStage
import co.maytes.standupbot.shared.marketing.Claims
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Page("/app/onboarding/welcome")
@Composable
fun OnboardingWelcomePage() = AuthGuard {
    WizardStage {
        val ctx = rememberPageContext()

        WizardFrame(
            title = "Set up your first standup",
            subline = "Takes ${Claims.SETUP_TIME}. Pause anywhere and we remember where you are.",
            art = {
                WizardFlow(
                    nodes = listOf(
                        FlowNode(WizardBrand.Linear),
                        FlowNode(WizardBrand.StandupBot),
                        FlowNode(WizardBrand.Slack),
                    ),
                    flowing = true,
                )
            },
            footerEnd = {
                Button(
                    label = "Get started",
                    variant = ButtonVariant.Primary,
                    onClick = { ctx.router.navigateTo(OnboardingStep.Slack.path) },
                )
            },
        ) {
            Ol(attrs = { classes("sb-wiz-timeline") }) {
                TimelineStep(
                    title = "Connect Slack",
                    hint = "Install StandupBot in your workspace.",
                ) { BrandChip(WizardBrand.Slack, ChipSize.Md) }
                TimelineStep(
                    title = "Link Linear",
                    hint = "Read-only access to assignee activity.",
                ) { BrandChip(WizardBrand.Linear, ChipSize.Md) }
                TimelineStep(
                    title = "Set up your standup",
                    hint = "Pick a channel, the people, and a schedule.",
                ) { WelcomeGlyph() }
                TimelineStep(
                    title = "Post your first standup",
                    hint = "Claude writes it and posts it to your channel.",
                ) { BrandChip(WizardBrand.Claude, ChipSize.Md) }
            }
        }
    }
}

@Composable
private fun WelcomeGlyph() {
    Div(attrs = { classes("sb-brand-chip") }) { LucideCalendar(size = 22) }
}

@Composable
private fun TimelineStep(title: String, hint: String, chip: @Composable () -> Unit) {
    Li(attrs = { classes("sb-wiz-tl-item") }) {
        chip()
        Div(attrs = { classes("sb-wiz-tl-text") }) {
            Span(attrs = { classes("sb-wiz-conn-title") }) { Text(title) }
            Span(attrs = { classes("sb-wiz-conn-detail") }) { Text(hint) }
        }
    }
}
